import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// ✅ Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyCEE0hVReOwmZ8WuI98W62RJNxKRGE_bIQ",
  authDomain: "wholenessforward.firebaseapp.com",
  projectId: "wholenessforward",
  storageBucket: "wholenessforward.appspot.com",
  messagingSenderId: "460175241957",
  appId: "1:460175241957:web:0f4141e04668d02e985a0c",
  measurementId: "G-DNXTYDH436"
};

// ✅ Initialize Firebase *before* exporting anything
const app = initializeApp(firebaseConfig);

// ✅ Initialize Auth and Provider *after* Firebase app is initialized
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// ✅ Export Auth & Provider
export { auth, googleProvider };
